import type { IdentityVerification } from '../../schemas/dancer-form.schema';
import IdentityDocumentConfigService from '../../services/identity-document-config.service';

/**
 * Next identity value when the issuing country changes, and the country the
 * entered documents now belong to.
 *
 * Only a move to a different, non-empty country resets the document number and
 * the uploaded photos. A clear (`''`) discards nothing, and re-picking the
 * country the documents belong to restores it as it was. Before, clearing the
 * field and picking Switzerland again wiped a dancer's uploaded ID photos
 * (review of the 2026-10-06 Autocomplete change).
 */
export function identityCountryChange(
  current: IdentityVerification,
  countryCode: string,
  docsCountry: string,
  documentOnly: boolean,
): { value: IdentityVerification; docsCountry: string } {
  if (!countryCode || countryCode === docsCountry) {
    return { value: { ...current, countryCode }, docsCountry };
  }
  const config = IdentityDocumentConfigService.getCountryConfig(countryCode);
  const value: IdentityVerification = {
    ...current,
    countryCode,
    documentType: config.preferredDocument,
    documentNumber: '',
  };
  if (!documentOnly) {
    value.frontImageUrl = '';
    value.backImageUrl = '';
    value.selfieImageUrl = '';
  }
  return { value, docsCountry: countryCode };
}
